import React from "react";
import { motion } from "framer-motion";
import { pageTransition, useMotionPrefs, withMotionPrefs } from "@/lib/motion";

export default function PageTransition({ children, className = "" }) {
  const { isReduced } = useMotionPrefs();
  const variants = withMotionPrefs(pageTransition, isReduced);

  return (
    <motion.div
      className={className}
      variants={variants}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      {children}
    </motion.div>
  );
}
